export const fonts = {
  primary: `'Open Sans', sans-serif`,
  secondary: `sans-serif`,
};
